'use client';

import { Box, BoxProps, Container, ContainerProps } from '@chakra-ui/react';

interface PageContentProps extends BoxProps {
  containerProps?: ContainerProps;
}

export function PageContent({
  children,
  containerProps,
  ...props
}: PageContentProps) {
  return (
    <Box backgroundColor="white" {...props}>
      <Container
        maxW={{ mobile: '100vw', desktop: '1440px' }}
        px={{ mobile: '4', desktop: '10' }}
        py={{ mobile: '10', desktop: '10' }}
        {...containerProps}
      >
        {children}
      </Container>
    </Box>
  );
}
